import { AxiosInstance } from 'axios';
import { format } from 'date-fns';
import querystring from 'querystring';
import { formDataInputs } from '@/tools/formdatainputs';
import { parseList } from './utils';
import {
  nokoPoints,
  List,
  ProgressFormData,
  CompetitionFormData,
  MentorsList,
} from './types';

const getProgressListData = (api: AxiosInstance) => ({
  getProgressList: async (
    siteUserId: string,
    competitionId?: string,
    studentId?: string,
    limit: number = 100,
  ): Promise<List> => {
    const { data } = await api.get(nokoPoints.GET_LIST, {
      params: { siteUserId, limit, competitionId, studentId },
    });
    return { ...data, data: parseList(data.data) };
  },
});

const postProgressData = (api: AxiosInstance) => ({
  postProgress: async (payload: ProgressFormData): Promise<any> => {
    const { date_finish } = payload;
    const formData = formDataInputs({
      ...payload,
      date_finish: format(date_finish, 'YYYY-MM-DD'),
    });

    const { data } = await api.post(nokoPoints.POST_PROGRESS, formData);
    return data;
  },
});

const postCompetitionData = (api: AxiosInstance) => ({
  postCompetition: async (payload: CompetitionFormData): Promise<any> => {
    const formData = querystring.stringify(payload);
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };

    const { data } = await api.post(
      nokoPoints.POST_COMPETITION,
      formData,
      config,
    );

    return data;
  },
});

const getMentorsData = (api: AxiosInstance) => ({
  getMentors: async (term: string): Promise<MentorsList> => {
    const { data } = await api.get(nokoPoints.GET_MENTORS, {
      params: { term },
    });
    return data;
  },
});

const nokoService = (api: AxiosInstance) => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...getProgressListData(api),
    ...postProgressData(api),
    ...postCompetitionData(api),
    ...getMentorsData(api),
  };
};

export default nokoService;



// WEBPACK FOOTER //
// ./src/services/noko/nokoService.ts